
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import Chart from 'chart.js'
import { Pie, mixins } from 'vue-chartjs'

@Component
export default class DoughnutGraph extends Mixins(Pie, mixins.reactiveProp) {
  @Prop() public chartData: any
  @Prop() public chartOptions: any

  mounted () {
    this.renderChart(this.chartData, this.chartOptions)
    let legend: string = this.$data._chart.generateLegend()

    if (legend.charAt(0) === '1') {
      let chart: any = document.getElementById('legend-1')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    }

    if (legend.charAt(0) === '2') {
      let chart: any = document.getElementById('legend-2')
      // 判定のためにつけた1文字目を削除
      legend = legend.slice(1)
      chart.innerHTML = legend
    }
  }

  /* chartjsの関数を定義 */
  public renderChart!: (chartData: any, options: any) => void
}
